module.exports = __webpack_public_path__ + "img/returnLeft.fe0b15bd.svg";